import WavesLogo from '../../../../ui/svg/common/waves-logo';
import React from 'react';
import CloseIcon from '../../../../ui/svg/common/close';
import { useDispatch } from 'react-redux';
import { rootActions, useAppSelector } from '../data/store';
import { getSelectedTab } from '../domain/mobile-top-menu-provider';

const TopPanel = () => {

    const dispatch = useDispatch();

    const data = useAppSelector(store => store.root.data);
    const selectedTabId = useAppSelector(store => store.root.selectedTabId);
    const selectedTab = getSelectedTab(data, selectedTabId);

    const close = () => {
        dispatch(
            rootActions.toggle({
                isOpened: false,
            })
        )
    };

    return (
        <section className="flex items-center justify-between px-6 py-3">
            <WavesLogo width="30px" height="30px" color="#ffffff" classes="ml-1" />

            <p className="font-bold text-3xl text-center">{ selectedTab?.tabName || '' }</p>

            <button
                type="button"
                title="Close"
                onClick={ close }>
                <CloseIcon width="16" color="#ffffff" />
            </button>
        </section>
    )
};

export default TopPanel;